(function ($, undefined) {
    var attributeName = 'data-roc-params';

    $.fn.getRocParamsObject = function () {
        var rocParamsValue = $(this).attr(attributeName);
        if (rocParamsValue !== undefined && rocParamsValue !== '') {
            try {
                return JSON.parse(rocParamsValue);
            } catch (e) {
                // empty catch
            }
        }
        return {};
    }

    $.fn.setRocParam = function (key, value) {
        var params = $(this).getRocParamsObject();
        params[key] = value;
        $(this).attr(attributeName, JSON.stringify(params));
        return this; // return 'this' for chainability
    }



    $.fn.getRocParam = function (key) {
        if (key !== undefined && key !== null) {
            var rocParams = $(this).getRocParamsObject();
            if (rocParams.hasOwnProperty(key)) {
                return rocParams[key];
            }
        }
        return null;
    }
}(jQuery));
define("plugins/jquery.rocparams", ["jquery"], function(){});

